"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var DepNode = /*#__PURE__*/(0, _createClass2["default"])(function DepNode(key) {
  (0, _classCallCheck2["default"])(this, DepNode);
  this.key = key;
  this.incoming = [];
  this.outgoing = [];
});
var buildDepsMap = function buildDepsMap(compKeys, moduleManage) {
  var nodeMap = {};
  compKeys.forEach(function (compKey) {
    nodeMap[compKey] = nodeMap[compKey] || new DepNode(compKey);
    var module = moduleManage.installedModules[compKey];
    module.compDependencies.forEach(function (depCompKey) {
      if (!moduleManage.installedModules[depCompKey]) {
        return;
      }
      nodeMap[depCompKey] = nodeMap[depCompKey] || new DepNode(depCompKey);
      nodeMap[depCompKey].outgoing.push(nodeMap[compKey]);
      nodeMap[compKey].incoming.push(nodeMap[depCompKey]);
    });
  });
  return nodeMap;
};
var topologicalSort = function topologicalSort(compKeys, moduleManage) {
  var nodeMap = buildDepsMap(compKeys, moduleManage);
  var sorted = [];
  var visited = {};
  var _visit = function visit(node) {
    if (visited[node.key]) {
      return;
    }
    visited[node.key] = true;
    node.incoming.forEach(function (outNode) {
      _visit(outNode);
    });
    sorted.push(node.key);
  };
  Object.keys(nodeMap).forEach(function (key) {
    _visit(nodeMap[key]);
  });
  return sorted;
};
var _default = exports["default"] = topologicalSort;